// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"styles_tagsContainer__Dh_wR","tag":"styles_tag__qsSTx","tagDivider":"styles_tagDivider__cuu1f"};